<script>
import FloatingFrame from "../components/floatingFrame";
import axios from "axios";
import Cookies from "js-cookie";
import { login_url, changePassword } from "@/api/url";
import { eventBus } from "@/helper/EventBus";
export default {
  name: "user",
  components: {
    FloatingFrame,
  },
  data() {
    return {
      username: "",
      passwordFormVisible: false, //修改密码表单
      showDropDownList: false, //下拉列表
      showFloatingBg: false, //弹出框背景
      isClickFloatingClose: false, //点击弹出框背景是否隐藏弹出层
      formData: {
        oldPassword: "",
        newPassword: "",
        checkPassword: ""
      },
      forceChangePasswordFlag: false, // 是否强制修改密码
      showOldPassword: false,
      showNewPassword: false,
      showCheckPassword: false
    };
  },
  created() {
    this.username = Cookies.get("userName");
    console.log("user created");
    // eventBus.$on('user-event',this.handleUserEventData)
  },
  mounted() {
    console.log("[user.vue] mounted");
    // 强制弹窗测试
    // this.passwordFormVisible = true;
    // this.showFloatingBg = true;
    // localStorage.removeItem('forceChangePassword');
    // console.log('[user.vue] 强制弹窗');

    // 正常逻辑
    console.log('localStorage.getItem("forceChangePassword"):', localStorage.getItem("forceChangePassword"));
    if (localStorage.getItem("forceChangePassword") === "1") {
      this.passwordFormVisible = true;
      this.showFloatingBg = true;
      this.forceChangePasswordFlag = true;
      console.log("[user.vue] 弹出修改密码弹窗");
    }
  },
  beforeDestroy() {
    eventBus.$off("user-event", this.handleUserEventData);
  },
  methods: {
    checkPasswordRule(password) {
      if (password.length < 8) return false;
      if (!/[A-Z]/.test(password)) return false;
      if (!/[a-z]/.test(password)) return false;
      if (!/[0-9]/.test(password)) return false;
      if (!/[^A-Za-z0-9]/.test(password)) return false;
      return true;
    },
    handleUserEventData(data) {
      console.log("handleUserEvent", data);
      this.username = data;
    },
    showList() {
      this.showFloatingBg = true;
      this.showDropDownList = true;
      this.isClickFloatingClose = true;
    },
    hiddenList() {
      this.showFloatingBg = false;
      this.showDropDownList = false;
    },
    hiddenFloatingBg() {
      if (this.isClickFloatingClose) {
        this.showFloatingBg = false;
        this.showDropDownList = false;
      } else {
        this.showFloatingBg = true;
      }
    },
    editPassword() {
      this.hiddenList();
      this.showFloatingBg = true;
      this.passwordFormVisible = true;
      this.isClickFloatingClose = false;
      this.forceChangePasswordFlag = false;
    },
    editPasswordTrue() {
      const { oldPassword, newPassword, checkPassword } = this.formData;
      if (!oldPassword || !newPassword || !checkPassword) {
        this.$message.warning("旧密码，新密码，确认密码不能为空");
        return;
      }
      if (!this.checkPasswordRule(newPassword)) {
        this.$message.warning("新密码不符合规则：不少于8位，包含数字、大小写字母、特殊字符！");
        return;
      }
      if (newPassword !== checkPassword) {
        this.$message.warning("新密码和确认密码不一致");
        return;
      }
      this.passwordFormVisible = false;
      this.showFloatingBg = false;
      this.$postRequest(
        changePassword() +
          "?oldPass=" +
          encodeURIComponent(oldPassword) +
          "&newPass=" +
          encodeURIComponent(newPassword),
        {}
      ).then((data) => {
        if (!data.data) {
          this.$notify.error({
            title: "失败",
            message: "旧密码输入错误！",
          });
        } else {
          this.$notify({
            title: "成功",
            message: "密码修改成功！",
            type: "success",
          });
          // 密码修改成功后，移除强制修改密码标志
          localStorage.removeItem("forceChangePassword");
        }
      });
      this.formData = {
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
      };
    },
    canclePassword() {
      this.passwordFormVisible = false;
      this.showFloatingBg = false;
      this.forceChangePasswordFlag = false;
    },
    getInfo(e, info) {
      if (info === "旧密码") {
        this.formData.oldPassword = e.target.value;
      }
      if (info === "新密码") {
        this.formData.newPassword = e.target.value;
      }
      if (info === "确认密码") {
        this.formData.checkPassword = e.target.value;
      }
    },
    //暂未使用
    vali(e, info) {
      const value = e.target.value;
      if (!value) {
      }
    },
    logout() {
      var _this = this;
      axios({
        method: "delete",
        url: login_url() + "?access_token=" + Cookies.get("Authorization"),
        headers: { Authorization: "Basic dnVlOnZ1ZQ==" },
      })
        .then(function (response) {
          var data = response.data;
          if (data.status == 200) {
            Cookies.remove("Authorization", { path: "" });
            if (Cookies.get("checkedOutside") != 1) {
              Cookies.remove("usernameOutside");
            }
            _this.$router.push("/");
          }
        })
        .catch(function (error) {});
    },
  },

  render() {
    console.log(
      "[user.vue] render this.passwordFormVisible:",
      this.passwordFormVisible
    );
    const { username, passwordFormVisible, showDropDownList, formData } = this;
    const {
      logout,
      showList,
      hiddenList,
      hiddenFloatingBg,
      editPassword,
      canclePassword,
      editPasswordTrue,
      getInfo,
    } = this;
    const passwordForm = () => {
      return passwordFormVisible ? (
        <div class="password-form">
          {this.forceChangePasswordFlag && (
            <div class="force-change-tip">
              <div>1. 请修改密码后，再使用系统！</div>
              <div>2. 密码要求：不少于8位，包含数字，大小写字母，特殊字符！</div>
            </div>
          )}
          <form>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>旧密码:
              </label>
              <input
                type={this.showOldPassword ? "text" : "password"}
                onInput={e => {
                  getInfo(e, "旧密码");
                }}
                value={formData.oldPassword}
              />
              <span class="eye-icon" onClick={() => { this.showOldPassword = !this.showOldPassword; }}>
                {this.showOldPassword ? "🙈" : "👁️"}
              </span>
            </div>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>新密码:
              </label>
              <input
                type={this.showNewPassword ? "text" : "password"}
                onInput={e => {
                  getInfo(e, "新密码");
                }}
                value={formData.newPassword}
              />
              <span class="eye-icon" onClick={() => { this.showNewPassword = !this.showNewPassword; }}>
                {this.showNewPassword ? "🙈" : "👁️"}
              </span>
            </div>
            <div class="edit-password-item">
              <label>
                <span class="edit-password-item-tip">*</span>确认密码:
              </label>
              <input
                type={this.showCheckPassword ? "text" : "password"}
                onInput={e => {
                  getInfo(e, "确认密码");
                }}
                value={formData.checkPassword}
              />
              <span class="eye-icon" onClick={() => { this.showCheckPassword = !this.showCheckPassword; }}>
                {this.showCheckPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </form>
          <div class="dialog-footer">
            <el-button type="primary" onClick={editPasswordTrue}>
              确 定
            </el-button>
            {!this.forceChangePasswordFlag && (
              <el-button onClick={canclePassword}>取 消</el-button>
            )}
          </div>
        </div>
      ) : (
        <div />
      );
    };
    return (
      <div class="userInfo">
        <div onClick={showList}>
          <img src={require("@/assets/images/menu_img/user.png")} />
          <span>{username}</span>
        </div>
        <ul
          class="userInfo-dropdown-list userInfo-dropdown-list-hidden"
          style={{ display: showDropDownList ? "block" : "none" }}
        >
          <li onClick={editPassword}>修改密码</li>
          <li onClick={logout}>退出</li>
        </ul>
        {this.showFloatingBg && <div class="user-mask-bg"></div>}
        <FloatingFrame
          showFloatingBg={this.showFloatingBg}
          on-func={hiddenFloatingBg}
        ></FloatingFrame>
        {passwordForm()}
      </div>
    );
  },
};
</script>
<style lang='scss'>
.userInfo {
  margin-left: -5px;
  margin-right: 20px;
  cursor: pointer;
  position: relative;

  .el-button--default span {
    color: #606266 !important;
  }
}
.userInfo-dropdown-list {
  position: absolute;
  // top: 60px;
  // right:70px;
  width: 150px;
  height: 100px;
  background: white;
  box-shadow: 0 0 10px 1px #333;
  border-radius: 4px;
  z-index: 25000 !important;
  padding: 0 10px;
  box-sizing: border-box;
  li {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ccc;
  }
}
.userInfo-dropdown-list-hidden {
  display: none;
}
.password-form {
  width: 400px;
  min-height: 340px;
  position: fixed;
  z-index: 30000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 32px 32px 24px 32px;
  box-shadow: 0 8px 32px 0 rgba(0,0,0,0.18);
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  animation: myfirst 0.8s;
}

.force-change-tip {
  background: #fffbe6;
  border: 1px solid #ffe58f;
  color: #d48806;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 18px;
  font-size: 15px;
  line-height: 1.7;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.edit-password-item {
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  position: relative;
}
.edit-password-item label {
  text-align: right;
  width: 90px;
  font-weight: 500;
  color: #333;
}
.edit-password-item input {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  height: 38px;
  width: 220px;
  box-sizing: border-box;
  padding-left: 12px;
  margin-left: 12px;
  font-size: 15px;
  transition: border 0.2s;
}
.edit-password-item input:focus {
  border: 1.5px solid #409eff;
  outline: none;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 18px;
}
.el-button--primary {
  background: linear-gradient(90deg, #409eff 0%, #66b1ff 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  padding: 0 24px;
  height: 38px;
  font-size: 15px;
  box-shadow: 0 2px 8px rgba(64,158,255,0.08);
}
.el-button {
  border-radius: 6px;
  height: 38px;
  font-size: 15px;
}

@keyframes myfirst {
  from {
    opacity: 0;
    transform: translate(-50%, -40%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
/* 弹窗背景遮罩层 */
.user-mask-bg {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.force-change-tip {
  color: #e6a23c;
  margin-bottom: 10px;
  font-size: 15px;
  line-height: 1.6;
}
.eye-icon {
  margin-left: -30px;
  cursor: pointer;
  user-select: none;
  font-size: 18px;
  color: #999;
  position: relative;
  z-index: 1;
}
</style>


